import React from "react";
import ReactDOM from "react-dom";
import "index.css";
import "mapbox-gl/dist/mapbox-gl.css";
import "assets/styles/garrison.css";
import AppContainer from "views/AppContainer/AppContainer";
import reportWebVitals from "reportWebVitals";

ReactDOM.render(
  <React.StrictMode>
    <AppContainer />
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
